import React, { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { getRotatedRectBoundingBox, isNearCardinal } from "@/sx-layout/components/plotmap/util/coords";
import { useFloatingRightPosition } from "@/sx-layout/components/settings/plotPlanMapping/hooks/useFloatingRightPosition";
import { MapState } from "@/sx-layout/hooks/useMapState";

type Props = {
  mapState: MapState;
  rect: {
    top: number;
    left: number;
    width: number;
    height: number;
    rotation?: number;
  };
  onEdit: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  onDelete: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
};

export const PlotPlanDetailSubMenu: FC<Props> = ({ mapState, rect, onEdit, onDelete }) => {
  const { t } = useTranslation();
  const { scale } = mapState;

  const boundingBox = useMemo(() => {
    return getRotatedRectBoundingBox(rect.left, rect.top, rect.width, rect.height, rect.rotation ?? 0);
  }, [rect.left, rect.top, rect.width, rect.height, rect.rotation]);

  const margin = useMemo(() => (isNearCardinal(rect.rotation ?? 0) ? 20 : 0), [rect.rotation]);

  const { top, left, transformOrigin } = useFloatingRightPosition(
    boundingBox,
    mapState,
    { width: 140, height: 72 },
    margin
  );

  return (
    <div
      id="layout-target-submenu"
      className="z-10 absolute"
      style={{
        transform: `scale(${scale})`,
        transformOrigin: transformOrigin,
        left,
        top,
      }}
    >
      <div className="bg-[#f3f2ef] p-[5px] w-[140px] font-bold rounded-[5px]">
        <ul className="bg-[#f3f2ef]">
          <li
            onClick={onEdit}
            className="bg-[#fff] hover:bg-[#fff8ee] cursor-pointer rounded flex items-center justify-center p-[5px] text-[13px] mb-[5px]"
          >
            {t("edit_area_detail")}
          </li>
          <li
            onClick={onDelete}
            className="bg-[#ffdddd] hover:bg-[#f8d0d0] cursor-pointer rounded flex items-center justify-center p-[5px] text-[13px]"
          >
            {t("remove")}
          </li>
        </ul>
      </div>
    </div>
  );
};
